module.exports = __webpack_public_path__ + "static/media/getstarted-bg.1a7c9437.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/getstarted-bg.png
// module id = UKWu
// module chunks = 89